/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState,useEffect } from 'react';
import PropTypes from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import FormValidation from '../../atoms/formEnums/formValidation';
import Label from '../../atoms/label/label';
import './formJSONComponent.scss';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import Icon, { IconType } from '../../atoms/icon/icon';
import FormPopup from '../formPopup/formPopup';
import FormJSONBlock from './formJSONBlock';
import swal from 'sweetalert';
import { connect, useSelector, shallowEqual, useDispatch } from 'react-redux';
import { storeStructure } from '../../../store/reducers';
import { forEach } from 'lodash';

/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const FormJSONComponent = (props) => {
  const {
    validation, label,configFile, helpText, value, 
    onChangeJsonObject,mode,parentId,parent,params,uniqueId,parentUID,canCreate,canRemove,canEdit,returnedPopupValues,
    onPopupOpenned,extraValues,classCss,formGroupValue,isDisabledWhen
  } = props;

  // const [valueState, setValueState] = useState(value);
  const [valueObj,setValueObj] =useState([]);
  const [popupShow,setPopupShow] =useState(false);
  const [popupData,setPopupData] =useState({});
  const [popupMode,setPopupMode] =useState("new");
  const [popupId,setPopupId] = useState(null);
  const [parentData,setParentData] =useState(null);
  const [nextId,setNextId] = useState(null);
  const [uID,setUID] =useState(null);
  const [pUID,setPUID]=useState(null);
  const [visibleBlock,setVisibleBlock] =useState(true);
 
  const getNewId=(values)=>{
    let max=0;
    valueObj.forEach(element => {
      if(element.id>max)
        max=element.id; 
      }
    );
    return max+1;
    // return Math.floor((Math.random()*10000)+1);
  }
  const handlerClosePopup=(e)=>{
    setPopupData(null);
    setParentData(null);
    setPopupShow(false);
    onPopupOpenned(false);
  }
  const handlerChangePopup=(e,field,values,id)=>{
    Object.keys(values).forEach((el)=>{
      if(values[el]=="(Empty)"){
        values[el]="";
      }
    });
    if(values){
     const newValues=[...valueObj];
     let foundIndex=newValues.findIndex((element)=>element.id==id);
     
     if(foundIndex!=-1){

        newValues[foundIndex]=values;
     }
     setValueObj(newValues);
     onChangeJsonObject(field,id,newValues,parent,parentId);
    }
    setPopupShow(false);
    onPopupOpenned(false);
    setPopupData(null);
  }
  const handlerNewPopup=(e,field,values)=>{
    if(values){
     let valuesWithID={...values,...{id:getNewId(values)}};
     let newValues=valueObj.concat(valuesWithID);
     setValueObj(newValues);
     onChangeJsonObject(field,null,newValues,parent,parentId);
    }
    setPopupShow(false);
    onPopupOpenned(false);
  }

  const handlerEditElement=(field,id)=>{
    
    let foundIndex=valueObj.findIndex((element)=>element.id==id);
    if(foundIndex!=-1){
      setPopupId(id);
      setPopupMode("edit");
      setPopupData(valueObj[foundIndex]);
      setParentData(valueObj);
      setPopupShow(true);
      onPopupOpenned(true);
    }
  }

  const handlerDeleteElement=(parent,id,parentId)=>{
    
    swal({
      title: 'Remove element?',
      text: 'You are about to remove an element, the changes are taken place when you save the step',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if(ok){
        let foundIndex=valueObj.findIndex((element)=>element.id==id);
        if(foundIndex!=-1){
          valueObj.splice(foundIndex,1);
          setValueObj(valueObj);
          onChangeJsonObject(parent,parentId,valueObj);
        }
      }
    });   
  }
  const handlerBlockChange=(field,fieldId,values,parent,parentId)=>{
   
    if(parentId){
      let index = valueObj.findIndex((element) => element.id === parentId);
      if(index!=-1){
        let current=valueObj[index];
        let newCurrent={...current,[field]:values};
        valueObj[index]=newCurrent;
        onChangeJsonObject(parent,parentId,valueObj);
      }
    }else{
      onChangeJsonObject(null,null,null);
    }
  }
  const normalizeValue = (input) => {
    if (!input) return [];

    if (typeof input === 'string') {
      try {
        const parsed = JSON.parse(input);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch (e) {
        return [];
      }
    }

    if (Array.isArray(input) &&input.length === 1 &&typeof input[0] === 'string') {
      try {
        const parsed = JSON.parse(input[0]);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch (e) {
        return [];
      }
    }

    if (Array.isArray(input)) {
      return input;
    }

    return [input];
  };
  useEffect(() => {
    const normalizedValue = normalizeValue(value);

    setValueObj(normalizedValue);

    if (configFile.hideIfEmpty) {
      setVisibleBlock(normalizedValue.length !== 0);
    } else {
      setVisibleBlock(true);
    }
  }, [value, configFile.hideIfEmpty]);
  useEffect(() => {
    setUID(uniqueId);
    if(parentUID)
      setPUID(parentUID);
  }, []);
  const getNextId=(valueObj)=>{
    let i=0;
    valueObj.forEach((el)=>{
      if(el.id>i)
        i=el.id;
    });
    return i+1;
  } 
 
  const handlerNew = () => {

    let next = getNextId(valueObj);
    let unique = getUniqueId();
    setNextId(next);
    setUID(unique);
    let info;
    if(extraValues){
      info={...popupData, ...extraValues};
    
    }
    info={...popupData,["nextId"]:next,["uniqueId"]:unique};
    setPopupData(info)
    
    setPopupMode("new");
    setPopupShow(true);
    onPopupOpenned(true);
    setParentData(valueObj);
  }
  const getParams=()=>{
    if(params){
      let p=params[configFile["attributeName"]];
      if(p)
        return p;
      else
        return "";
    }else
    return "";
  }
  const getUniqueId=()=>{
    return Math.round(Math.random()*100000000000+100000000000);
  }
  const hasFlatIngestProcess = !valueObj || (Array.isArray(valueObj) && (valueObj.length === 0 || valueObj.some(el => el.type === 'flat')));
  return ( 
    <div className={'formJSONComponent '+(classCss?classCss:"")}>        
    {visibleBlock && 
    <div className={(mode=="related"?"related-block width100":`form-group row ingest-table text-${validation}`)}>
      <FormPopup size={'xl'} id={popupId} mode={popupMode} nextId={nextId} title={configFile.label} configFile={configFile.popupFormGroups} field={configFile.attributeName} parent={parent} value={popupData} show={popupShow} params={params} uniqueId={uID} parentUID={parentUID} parentData={parentData}
        onNewPopup={handlerNewPopup} 
        onEditPopup={handlerChangePopup}
        onClosePopup={handlerClosePopup} 
        extraValues={extraValues}/>
      <div className={`col-sm-12`+(mode=='related'?' related-title':' json-title')}>
        {mode!='related' &&<div className={`col-sm-8 column-title`}>
          { label !== ''
          && (
            <Label className={`ingest-label`} helpText={helpText}>{label}</Label>
          )}
        </div>}
        {mode=="related" &&   <div className='related-title-el related-title-el--text'>{configFile.label}</div>}
        {canCreate && (
          <div className={(mode=="related"
            ? 'related-title-el related-title-el--actions'
            : 'col-sm-4 column-title text-right')}
          >
            <Button
              id={configFile.attributeName+"--new"}
              className={"btn btn-primary btn-sm "+configFile.attributeName+"--new"}
              disabled={false}
              theme={ButtonTheme.SUCCESS}
              icon={IconType.NEW}
              title={'New'}
              onClick={handlerNew}
            />
          </div>
        )}
      </div>
      <div className="col-sm-12 row-data">
        {valueObj && valueObj.map((values,key)=>{
          return(
              <div key={configFile.attributeName+key+Math.floor((Math.random()*10000)+1)} className={"columns-"+(configFile.columns?configFile.columns:"columns-1")}>
                <div className='margin-5'>
                  {values && 
                    <FormJSONBlock 
                        key={key} canEdit={canEdit} canRemove={canRemove} 
                        value={values} configFile={configFile} fields={configFile.popupFormGroups[0].fields} parentId={parentId} parent={configFile.attributeName} uniqueId={uID} parentUID={parentUID}
                        onChange={handlerBlockChange} 
                        onDelete={handlerDeleteElement} 
                        onEdit={handlerEditElement} 
                        onPopupOpenned={onPopupOpenned}
                        formGroupValue = {value}
                        extraValues={extraValues}
                        params={params}/>}
                </div>
              </div>
          );
        })}
      </div>
    </div>}
    </div>
  );
};

FormJSONComponent.propTypes = {
  /**
   * Select form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
   * Defined text errors
   */
  errorText: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Initial input value
   */
  value: PropTypes.oneOfType([PropTypes.array]),
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  onNew:PropTypes.func,
  popupOpenStatus:PropTypes.func,
};

FormJSONComponent.defaultProps = {
  validation: FormValidation.PENDING,
  errorText: '',
  label: '',
  helpText: '',
  values:[],
  configFile:{},
  mode:'',
  canCreate:true,
  canRemove:true,
  canEdit:true,
  parentId:null,
  onChange: () => {},
  popupOpenStatus:()=>{}
};

export default FormJSONComponent;